<template>
	<select @change='change' v-model="selected" class='form-control my-control table-control'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const ACTION_TYPE = 'get_action_type.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'actionType',
		data: function () { 
			return {
				selected: '0',
				options: []
			}
		},
		props: {
			line_count: '',
			id: null
		},
		methods: {
			change () {
				EventBus.$emit(`action_type`, {index: this.line_count, value: this.selected})
			}
		},
		created: function () {
			fetch(DB + ACTION_TYPE, {
				credentials: 'include'
			})
			.then(data => data.json())
			.then(data => {
				if (data) {
					this.options = data
					if(this.id) {
						this.selected = this.id
						this.change()
					}
				}
				else {
					this.options = []
				}
			})
			.catch(err => console.log(err))
		}
	}
</script>


// WEBPACK FOOTER //
// actionType.vue?4c62972f